var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentManagement01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 0.75px;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Payment Management") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.5,
    y: 9.62,
    width: 18.42,
    height: 11.48,
    rx: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.67,9.31,5.76,3.25a1,1,0,0,1,1.16-.78L22.7,5.93a1,1,0,0,1,.77,1.25l-2.18,8.33a.75.75,0,0,1-.88.53l-.84-.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.72,
    y1: 5.46,
    x2: 23.01,
    y2: 8.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.79,
    y: 13.66,
    width: 5.04,
    height: 2.37,
    rx: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.05,
    y1: 18.78,
    x2: 6.73,
    y2: 18.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.05,
    y1: 18.78,
    x2: 11.72,
    y2: 18.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 14.06,
    y1: 18.78,
    x2: 16.73,
    y2: 18.78
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentManagement01);
export default __webpack_public_path__ + "static/media/Payment_Management_01.43a14d226af2cbf53b69b4e51f174883.svg";
export { ForwardRef as ReactComponent };